import * as React from "react";
import styled, { css } from "styled-components";
function ListComponent(props) {
    const { ordered, className, children } = props;
    if (ordered) {
        return React.createElement("ol", { className: className }, children);
    }
    else {
        return React.createElement("ul", { className: className }, children);
    }
}
export const List = styled(ListComponent) `
  padding: 0;
  margin: 0;
  ${(props) => `list-style: ${props.listStyle || "none"};`};
`;
export const MarkdownList = styled(ListComponent) `
  line-height: 1.4em;
`;
export function OrderedMarkdownList(props) {
    return React.createElement(MarkdownList, { ordered: true }, props.children);
}
export function UnorderedMarkdownList(props) {
    return React.createElement(MarkdownList, null, props.children);
}
export const ListItem = styled.li `
  display: block;
  margin-top: 1em;
  ${(props) => props.horizontal &&
    css `
      margin-top: 0;
      display: inline-block;
      padding-right: 3em;

      &:last-child {
        padding-right: 0;
      }
    `};
`;
export const HorizontalList = styled(List) `
  display: block;
  list-style: none;
  margin: 0;
  padding: 0;
`;
